/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('widgetTopPages', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/top_pages_widget.html',
    bindings: {
      project: '<',
    },
    controllerAs: 'vm',
    controller: function(ZcsDashboardData) {
      const vm = this;
      const demoData = [
        {
          url: 'https://www.example.com',
          weeklyData: [{ value: 98 }, { value: 75 }],
        }, {
          url: 'https://www.example.com/sale',
          weeklyData: [{ value: 60 }, { value: 0 }],
        }, {
          url: 'https://www.example.com/categories/1',
          weeklyData: [{ value: 42 }, { value: 38 }],
        }, {
          url: 'https://www.example.com/items/123',
          weeklyData: [{ value: 25 }, { value: 52 }],
        }, {
          url: 'https://www.example.com/items/789',
          weeklyData: [{ value: 24 }, { value: 18 }],
        }, {
          url: 'https://www.example.com/items/456',
          weeklyData: [{ value: 10 }, { value: 12 }],
        }
      ];

      // variables
      vm.topPages = [];

      // actions

      this.$onInit = () => {
        if(vm.project.is_demo) {
          vm.topPages = demoData;
        } else {
          ZcsDashboardData.find({
            apikey: vm.project.apikey,
            date: moment().subtract(7, 'days').startOf('day').toDate()
          }).then(res => {
            if(res.top_pages_by_canonical_url && res.top_pages_by_canonical_url.length > 0) {
            // remove null canonical_urls..
              vm.topPages = _.filter(res.top_pages_by_canonical_url, 'url');
            } else if(res.top_pages_by_url && res.top_pages_by_url.length > 0) {
              vm.topPages = res.top_pages_by_url;
            } else {
              vm.topPages = demoData;
              vm.showNoDataOverlay = true;
            }
            vm.topPages = _.reject(vm.topPages, p => !p.url || p.url === 'undefined' || p.url === 'null');
          });
        }
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/top_pages_widget.js